/**
 * Tiện ích map key của object theo 2 kiểu: chữ HOA đầu (PascalCase) và chữ thường đầu (camelCase).
 *
 * Dùng ở tầng API chung (bootstrap/$Core.js) để mọi dữ liệu trả về từ API
 * đều truy cập được theo cả 2 kiểu key, ví dụ: data.TenKhachHang và data.tenKhachHang.
 */

export function toLowerFirst(s) {
    return s.charAt(0).toLowerCase() + s.slice(1);
}

export function toUpperFirst(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

/**
 * Chỉ nhận diện "plain object" (object literal `{}` hoặc tạo bằng
 * `Object.create(null)`). Các object đặc biệt như Blob, File, FormData,
 * Date, Map, Set, ArrayBuffer, hay instance của class... KHÔNG phải plain
 * object và phải được giữ nguyên (nếu đệ quy vào chúng, `Object.keys` trả
 * mảng rỗng -> biến thành `{}`, làm hỏng Blob khi tải/in file).
 */
function isPlainObject(input) {
    if (input === null || typeof input !== "object") return false;
    const proto = Object.getPrototypeOf(input);
    return proto === Object.prototype || proto === null;
}

/**
 * Đệ quy qua object/mảng, mỗi key sẽ tồn tại ở cả 2 dạng:
 * chữ HOA đầu và chữ thường đầu (cùng tham chiếu giá trị).
 * Chỉ transform plain object + mảng; giữ nguyên chuỗi, số, Date, Blob,
 * và mọi object không phải plain object khác.
 */
export function addBothCases(input) {
    if (Array.isArray(input)) {
        return input.map(addBothCases);
    }

    if (isPlainObject(input)) {
        const out = {};
        for (const key of Object.keys(input)) {
            const val = addBothCases(input[key]);
            out[toUpperFirst(key)] = val; // Chữ to ở đầu
            out[toLowerFirst(key)] = val; // chữ nhỏ ở đầu
        }
        return out;
    }

    return input;
}

export default addBothCases;
